import { ReactNode } from 'react';
import { useFeatureFlag, FormAsyncSelectField, FormAsyncSelectFieldProps } from '@mews/framework';
import { UnicodeEntity } from '@mews/enums';
import { Stack } from '@optimus-web/core';
import { FeatureFlag } from '@mews-commander/enums';
import { BillingSearchForReservationsForLinkingResult } from '@mews-commander/data-access';
import { useReservationsSearch } from './queries';
import { FutureStayBanner } from './FutureStayBanner';

interface ReservationListProps
    extends Omit<
        FormAsyncSelectFieldProps<BillingSearchForReservationsForLinkingResult>,
        'useDataQuery' | 'renderData'
    > {
    renderData: (data: BillingSearchForReservationsForLinkingResult) => ReactNode;
    defaultOptions: ReactNode;
    defaultValue?: string | null;
    defaultSearchValue?: string;
    showOnlyUnpaidReservations: boolean;
}

export const ReservationList = ({
    renderData,
    defaultOptions,
    defaultValue,
    defaultSearchValue,
    showOnlyUnpaidReservations = true,
    ...props
}: ReservationListProps) => {
    const isNewFinanceLedgersEnabled = useFeatureFlag(FeatureFlag.newFinanceLedgersEnabled);

    return (
        <Stack vertical spacing="200">
            <FormAsyncSelectField
                {...props}
                useDataQuery={useReservationsSearch(showOnlyUnpaidReservations)}
                renderData={renderData}
                defaultOptions={defaultOptions}
                defaultValue={defaultValue}
                defaultSearchValue={defaultSearchValue}
                data-test-select-name="reservation-link-select"
                displayMapper={(i: React.ReactElement) => (
                    <>
                        {i.props.label}
                        {UnicodeEntity.NoBreakSpace}
                        {i.props.rightDetail}
                    </>
                )}
            />

            {isNewFinanceLedgersEnabled && <FutureStayBanner />}
        </Stack>
    );
};
